/* eslint-disable import/prefer-default-export */
import * as Sentry from '@sentry/react';
import { IUser } from '../../types';

export const setUserInSentry = (user: IUser): void => {
  Sentry.setUser({ id: user.id, email: user.email });
};
